import { assign } from 'lodash';

export default function(state) {
  if (state === undefined) {
    return {};
  }
  return assign({}, state);
}
